export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  modules: {},
  getters: {
    hasPermission(state, getters, rootState) {
      return to => {
        if (rootState.auth.user.is_superuser) return true;
        const currentOrganizationPermissions =
          rootState.shell.currentOrganizationPermissions;
        if (to.meta && to.meta.permissions) {
          const permissions = Array.isArray(to.meta.permissions)
            ? to.meta.permissions
            : [to.meta.permissions];
          for (let permission of permissions) {
            if (currentOrganizationPermissions.includes(permission))
              return true;
          }
          return false;
        } else return true;
      };
    }
  }
};
